export default __webpack_public_path__ + "static/media/fluent-preview.d8d14e8b.png";